import { Badges, H5, H6, P } from "../../../../AbstractElements";
import { MeetUpText, MeetUpTimelineTitle, PleaseMeetUp, WebDesignersMeeUp } from "../../../../Constant";

const MeetUpTimeline = () => {
  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-location bg-secondary">
        <i className="icon-pin-alt" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="success">{MeetUpTimelineTitle}</Badges>
        </div>
        <H5 className="m-0 vertical-timeline-element-subtitle">{WebDesignersMeeUp}</H5>
        <P className="mb-0">{MeetUpText}</P>
        <div className="time-content pt-2">
          <i className="icon-android"></i>
          <H6>{PleaseMeetUp}</H6>
        </div>
        <span className="cd-date">November 04 2022</span>
      </div>
    </div>
  );
};
export default MeetUpTimeline;
